import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {UserService} from '../../../../services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginService} from '../../../../services/login.service';
import {VerificationService} from '../../../../services/verification.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {ConfigService} from '../../../../services/config.service';
import {element} from "protractor";
import { CertificationService } from 'src/app/services/certification.service';
import {User} from "../../../../models/user.model";
import {ExportToCsv} from 'export-to-csv';

@Component({
    selector: 'app-certificats',
    templateUrl: './certificats.component.html',
    styleUrls: ['./certificats.component.css'],
    standalone: false
})
export class CertificatsComponent implements OnInit {
  @ViewChild('pdfExportArea') pdfExportArea: ElementRef;

  // tslint:disable-next-line:variable-name
  user_details: User = new User(); // Initialisation par défaut avec un objet User vide

  public admin_login = localStorage.getItem('admin_login');
  // tslint:disable-next-line:variable-name radix
  public site_id = parseInt(localStorage.getItem('site_id'));
  public user_conntected = JSON.parse(localStorage.getItem('currentUser'));
  // tslint:disable-next-line:variable-name
  public profile_id = this.user_conntected.profile_id;
  public takeInHand = localStorage.getItem('takeInHand');
  // tslint:disable-next-line:variable-name
  public connectLikeVerifcateur = localStorage.getItem('connect_like_verificateur');
  public user_url_id: any;
  public user_id: any;
  public users: any;
  private sub: any;
  public certificats: any;
  public sortField: 'status' | 'date_certification' | 'date_fin' | null = null;
  public sortDirection: 'asc' | 'desc' = 'asc';
  // barre de titre repliée par défaut : ne garde que "Certification", masque le détail (parcours / sous-certification)
  public showColumnLegend = false;
  // au delà de la fin de validité, on considère que le certificat expire "bientôt"
  private readonly EXPIRING_SOON_DAYS = 31;
  public entityType = this.configService.entityType;

  constructor(
    public translate: TranslateService,
    public pageTitle: Title,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private userService: UserService,
    private configService: ConfigService,
    private verificationService: VerificationService,
    private spinner: NgxSpinnerService,
    private config: ConfigService,
    private certificationService: CertificationService) {}
  currentDate: string;

  ngOnInit() {

    const today = new Date();
    this.currentDate = today.toDateString(); // Formate la date en une chaîne lisible
    this.configService.checkUSerAccessByProfile(this.profile_id);
    if(this.user_conntected.id)
    {
      this.user_id = this.user_conntected.id;
    }
    else{
      this.user_id = this.user_conntected.user_id;
    }

    this.get_certification_by_user_login(this.user_conntected.login)

    this.sub = this.activatedRoute.params.subscribe(params => {
      this.user_url_id = params.id;
    });

    // si profile apprenant (3) verification si l'url corresponds a celle de l'user qui est connecté
    if (this.user_url_id == this.user_id ||this.user_url_id){
      this.user_certifications(this.user_url_id);
    }
      else if(this.profile_id===11 || this.takeInHand =='yes'){
        this.user_certifications(this.user_url_id);
    }
    else if(this.profile_id !==11 || this.profile_id !==3) {
      this.userService.getListIntervenant(this.profile_id, this.site_id, this.user_id)
        .subscribe(res => {
          // @ts-ignore
          this.users = res.data;
          const user_tab = [];
          for (let us of this.users) {
            user_tab.push(us.user.id)
          }
          for (let id of user_tab){
            if (id == this.user_url_id){
              this.user_certifications(this.user_url_id);
            }
          }
        }, (err) => {
          console.log(err);
        });
    }
    else{
      this.router.navigate(['dashboard/administrator']);
    }
  }


  // tslint:disable-next-line:variable-name
  user_certifications(id_user) {
    this.spinner.show();
    this.userService.get_all_intervenant_certifications_status(id_user)
      .subscribe(res => {
        this.user_details = res.user;
        this.certificats = res.certificats;
        this.sortNestedResults();
        this.applySort();
        this.spinner.hide();
      }, (err) => {
        console.log(err);
        this.spinner.hide();
        this.router.navigate(['dashboard/administrator']);
        return false;
      });
  }

  // tslint:disable-next-line:variable-name
  get_certification_by_user_login(login) {
    const body = {
      login : login,
    };
    this.certificationService.get_certification_by_user_login(body)
      .subscribe(res => {
        // @ts-ignore
        this.certificats_site = res.data.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      }, (err) => {
        console.log(err);

      });
  }

  toggleColumnLegend() {
    this.showColumnLegend = !this.showColumnLegend;
  }

  // construit une ligne par parcours / parcours de sous-certification, réutilisée par les exports Excel et PDF
  private buildExportRows(): any[] {
    const dataToExport = [];

    (this.certificats || []).forEach(certification => {
      (certification.parcours_result || []).forEach(pr => {
        dataToExport.push({
          'Certification': certification.certificat_name || '',
          'Sous-certification': '',
          'Titre du parcours': pr.parcour_label || '',
          'Statut du certificat': certification.certificat_statut || '',
          'Statut du parcours': this.formatStatusLabel(pr.status_label),
          'Durée de validité (mois)': certification.certificat_type_validite === 2 ? certification.certificat_delay + ' mois' : certification.certificat_date,
          'Date de certification': pr.date_validation || '',
          'Date de fin de validité': pr.lesson_status === 'not validated' ? 'NC' : (pr.date_fin_validite || '')
        });
      });

      (certification.sub_certifications || []).forEach(sub => {
        (sub.sub_certificat_result || []).forEach(scr => {
          dataToExport.push({
            'Certification': certification.certificat_name || '',
            'Sous-certification': sub.sub_certificat_name || '',
            'Titre du parcours': scr.parcour_label || '',
            'Statut du certificat': sub.sub_certificat_statut || '',
            'Statut du parcours': this.formatStatusLabel(scr.status_label),
            'Durée de validité (mois)': sub.sub_certificat_type_validite === 2 ? sub.sub_certificat_delay + ' mois' : sub.sub_certificat_date,
            'Date de certification': scr.date_validation || '',
            'Date de fin de validité': scr.lesson_status === 'not validated' ? 'NC' : (scr.date_fin_validite || '')
          });
        });
      });
    });

    return dataToExport;
  }

  // export du tableau des certificats affiché à l'écran (une ligne par parcours / parcours de sous-certification)
  exporterExcel() {
    const dataToExport = this.buildExportRows();

    const fullName = ((this.user_details.firstname || '') + ' ' + (this.user_details.name || '')).trim();
    const options = {
      fieldSeparator: ';',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Certificats' + (fullName ? ' - ' + fullName : ''),
      filename: 'certificats_' + (this.user_details.matricule || this.user_url_id),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(dataToExport);
  }

  // jsPDF/html2canvas sont chargés à la demande (import dynamique) pour ne pas alourdir le bundle initial.
  // On capture directement le DOM affiché à l'écran pour que le PDF soit visuellement identique,
  // en masquant les icônes (police d'icônes non gérée par html2canvas -> caractères illisibles).
  async exporterPdf() {
    const [{default: jsPDF}, {default: html2canvas}] = await Promise.all([
      import('jspdf'),
      import('html2canvas')
    ]);

    const element: HTMLElement = this.pdfExportArea.nativeElement;
    element.classList.add('pdf-exporting');
    // laisse Angular appliquer la classe (masquage des icônes) avant la capture
    await new Promise(resolve => setTimeout(resolve, 0));

    try {
      const canvas = await html2canvas(element, {scale: 2, useCORS: true});
      const imgData = canvas.toDataURL('image/png');

      const doc = new jsPDF({
        orientation: canvas.width > canvas.height ? 'landscape' : 'portrait',
        unit: 'px',
        format: [canvas.width, canvas.height]
      });
      doc.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
      doc.save('certificats_' + (this.user_details.matricule || this.user_url_id) + '.pdf');
    } finally {
      element.classList.remove('pdf-exporting');
    }
  }

  // à l'intérieur de chaque bloc, le parcours "valide" remonte au-dessus des expirés/invalidés
  private sortNestedResults() {
    if (!this.certificats) {
      return;
    }
    this.certificats.forEach(certification => {
      this.sortResultsByValidity(certification.parcours_result);
      if (certification.sub_certifications) {
        certification.sub_certifications.forEach(sub => {
          this.sortResultsByValidity(sub.sub_certificat_result);
        });
      }
    });
  }

  private sortResultsByValidity(results: any[]) {
    if (!results || !results.length) {
      return;
    }
    results.sort((a, b) => {
      // la date de certification la plus récente remonte en haut (dates manquantes en dernier)
      const aDate = this.parseDate(a.date_validation);
      const bDate = this.parseDate(b.date_validation);
      if (aDate && bDate && aDate.getTime() !== bDate.getTime()) {
        return bDate.getTime() - aDate.getTime();
      }
      if (!aDate !== !bDate) {
        return aDate ? -1 : 1;
      }
      // à date égale (ou toutes deux manquantes), le parcours "valide" remonte au-dessus
      const aValid = (a.status_label || '').toLowerCase() === 'valide' ? 0 : 1;
      const bValid = (b.status_label || '').toLowerCase() === 'valide' ? 0 : 1;
      return aValid - bValid;
    });
  }

  // "valide" s'affiche "Réussi" ; les autres statuts sont juste mis en majuscule initiale
  formatStatusLabel(statusLabel: string): string {
    if (!statusLabel) {
      return '';
    }
    if (statusLabel.toLowerCase() === 'valide') {
      return 'Réussi';
    }
    return statusLabel.charAt(0).toUpperCase() + statusLabel.slice(1);
  }

  // tri des blocs de certification (clic sur les titres de colonne triables)
  sortBy(field: 'status' | 'date_certification' | 'date_fin') {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }
    this.applySort();
  }

  // Le tri par statut suit le libellé réellement affiché dans le badge.
  // Pour les dates, les certificats valides restent au-dessus des expirés/invalidés
  // et le tri utilise exactement la date affichée en gras sur la ligne du certificat.
  applySort() {
    if (!this.certificats || !this.certificats.length) {
      return;
    }
    const dir = this.sortDirection === 'asc' ? 1 : -1;
    this.certificats.sort((a, b) => {
      if (this.sortField === 'status') {
        return dir * this.getCertificationStatusLabel(a).localeCompare(
          this.getCertificationStatusLabel(b),
          'fr',
          {sensitivity: 'base'}
        );
      }

      const groupA = this.isCertificationValid(a) ? 0 : 1;
      const groupB = this.isCertificationValid(b) ? 0 : 1;
      if (groupA !== groupB) {
        return groupA - groupB;
      }
      if (!this.sortField) {
        return 0;
      }
      if (this.sortField === 'date_certification') {
        return dir * this.compareDates(this.getCertificationDateValidation(a), this.getCertificationDateValidation(b));
      }
      return dir * this.compareDates(this.getCertificationDateFin(a), this.getCertificationDateFin(b));
    });
  }

  isCertificationValid(certification): boolean {
    return certification && certification.certificat_statut === 'Valide';
  }

  // Un certificat avec un parcours en cours n'est pas encore obtenu : il est donc "Non valide".
  // Le badge "Expiré" reste réservé aux certificats sans parcours en cours dont toutes les
  // sous-certifications requises sont valides.
  certificationNonValidLabel(certification): string {
    const hasResultInProgress = this.collectResults(certification).some(result =>
      (result.status_label || '').trim().toLowerCase() === 'en cours'
    );
    if (hasResultInProgress) {
      return 'Non valide';
    }
    if (certification && certification.sub_certifications && certification.sub_certifications.length
      && !certification.sub_certifications.every(sub => sub.sub_certificat_statut === 'Valide')) {
      return 'Non valide';
    }
    return 'Expiré';
  }

  private getCertificationStatusLabel(certification): string {
    if (!certification) {
      return '';
    }
    if (certification.certificat_statut === 'Non Valide') {
      return this.certificationNonValidLabel(certification);
    }
    return certification.certificat_statut || '';
  }

  certificationExpiringSoon(certification): boolean {
    return this.isDateWithinDays(this.getCertificationDateFin(certification), this.EXPIRING_SOON_DAYS);
  }

  subCertificationExpiringSoon(subCertification): boolean {
    return this.isDateWithinDays(this.getSubCertificationDateFin(subCertification), this.EXPIRING_SOON_DAYS);
  }

  // date de fin de validité affichée en haut du bloc certificat : celle du dernier parcours validé,
  // même si le certificat n'est plus valide aujourd'hui (on remonte la dernière certification obtenue).
  // Si le certificat repose sur des sous-certifications, tant qu'elles ne sont pas toutes validées on
  // n'affiche aucune date en haut (une seule sous-certification réussie ne suffit pas).
  getCertificationEndDate(certification): string {
    return this.formatDate(this.getCertificationDateFin(certification));
  }

  getSubCertificationEndDate(subCertification): string {
    return this.formatDate(this.getSubCertificationDateFin(subCertification));
  }

  // date de certification affichée en haut du bloc certificat : celle du dernier parcours validé
  // (voir getCertificationEndDate pour la règle sur les sous-certifications)
  getCertificationValidationDate(certification: any): string {
    return this.formatDate(this.getCertificationDateValidation(certification));
  }

  // tant que toutes les sous-certifications requises ne sont pas "Valide", on ne remonte pas de date
  // globale en haut du bloc (cf. certificationNonValidLabel qui applique la même règle au badge)
  private allSubCertificationsValid(certification): boolean {
    if (!certification || !certification.sub_certifications || !certification.sub_certifications.length) {
      return true;
    }
    return certification.sub_certifications.every(sub => sub.sub_certificat_statut === 'Valide');
  }

  getSubCertificationValidationDate(subCertification: any): string {
    const latest = this.latestValidatedResult(subCertification && subCertification.sub_certificat_result || []);
    return latest ? this.formatDate(this.parseDate(latest.date_validation)) : '';
  }

  // parmi les parcours ayant une date de certification, celui dont la date de certification est la plus récente
  private latestValidatedResult(results: any[]): any {
    return (results || [])
      .filter(r => r.lesson_status !== 'not validated' && this.parseDate(r.date_validation))
      .reduce((latest, r) => {
        if (!latest) {
          return r;
        }
        const rDate = this.parseDate(r.date_validation) as Date;
        const latestDate = this.parseDate(latest.date_validation) as Date;
        return rDate.getTime() > latestDate.getTime() ? r : latest;
      }, null);
  }

  // affiche le bandeau "a quitté l'établissement" quand la date de fin (départ) remonte à plus de 12 mois
  hasLeftEstablishment(): boolean {
    const endDate = this.parseDate(this.user_details && this.user_details.end_date);
    if (!endDate || endDate.getFullYear() <= 1970 || endDate.getFullYear() > 2060) {
      return false;
    }
    const departurePlusOneYear = new Date(endDate);
    departurePlusOneYear.setFullYear(departurePlusOneYear.getFullYear() + 1);
    return departurePlusOneYear.getTime() < new Date().getTime();
  }

  // arrondit les dates utilisateur (retire l'heure parfois ajoutée) et masque les dates sentinelles (ex: 01/01/1970, ou > 2060 pour "pas de fin")
  formatUserDate(dateStr: string): string {
    const date = this.parseDate(dateStr);
    if (!date || date.getFullYear() <= 1970 || date.getFullYear() > 2060) {
      return 'Non défini';
    }
    return this.formatDate(date);
  }

  private getCertificationDateValidation(certification): Date | null {
    if (!this.allSubCertificationsValid(certification)) {
      return null;
    }
    const latest = this.latestValidatedResult(this.collectResults(certification));
    return latest ? this.parseDate(latest.date_validation) : null;
  }

  private getCertificationDateFin(certification): Date | null {
    if (!this.allSubCertificationsValid(certification)) {
      return null;
    }
    const latest = this.latestValidatedResult(this.collectResults(certification));
    return latest ? this.parseDate(latest.date_fin_validite) : null;
  }

  private getSubCertificationDateFin(subCertification): Date | null {
    const latest = this.latestValidatedResult(subCertification && subCertification.sub_certificat_result || []);
    return latest ? this.parseDate(latest.date_fin_validite) : null;
  }

  // rassemble les résultats de parcours du certificat et de ses sous-certifications
  private collectResults(certification): any[] {
    let results = [];
    if (certification && certification.parcours_result && certification.parcours_result.length) {
      results = results.concat(certification.parcours_result);
    }
    if (certification && certification.sub_certifications && certification.sub_certifications.length) {
      certification.sub_certifications.forEach(sub => {
        if (sub.sub_certificat_result && sub.sub_certificat_result.length) {
          results = results.concat(sub.sub_certificat_result);
        }
      });
    }
    return results;
  }

  private parseDate(dateStr: string): Date | null {
    if (!dateStr) {
      return null;
    }
    const parts = dateStr.split('/');
    if (parts.length !== 3) {
      return null;
    }
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return null;
    }
    return new Date(year, month, day);
  }

  private formatDate(date: Date | null): string {
    if (!date) {
      return '';
    }
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    return `${day}/${month}/${date.getFullYear()}`;
  }

  private compareDates(a: Date | null, b: Date | null): number {
    if (!a && !b) {
      return 0;
    }
    if (!a) {
      return 1;
    }
    if (!b) {
      return -1;
    }
    return a.getTime() - b.getTime();
  }

  private isDateWithinDays(date: Date | null, days: number): boolean {
    if (!date) {
      return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diffDays = (date.getTime() - today.getTime()) / (1000 * 60 * 60 * 24);
    return diffDays >= 0 && diffDays <= days;
  }

}
